import { Box } from '@mui/material';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import useEventTypeSelector from 'modules/events/components/EventTypeSelector/EventTypeSelector.hook';
import SelectYoda from 'yoda-ui/components/Form/SelectYoda';
import { useYodaCreateForm, YodaFormProvider } from 'yoda-ui/yodaForm';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

export const EventTypeSelector: FC = () => {
  const { eventTypeSelectorConfig, handleEventTypeChange } = useEventTypeSelector();
  const yodaFormMethods = useYodaCreateForm({ setIsValidOptional: true });
  const flags = useFlags();
  return flags.eventsBiogenlinc4280EnablePhysicalEvents || flags.eventsBiogenlinc4745EnableHybridEvents ? (
    <YodaFormProvider { ...yodaFormMethods.providerFields }>
      <Box marginRight={ YodaSpacing.large } flex={ 1 }>
        <SelectYoda { ...eventTypeSelectorConfig } onChange={ handleEventTypeChange } />
      </Box>
    </YodaFormProvider>
  ) : null;
};
